import React from "react";

import { AddIcon, Button, EmptyState } from "shared/ui";
import { CurrencyFormatter } from "shared/lib/currencyFormatter";
import { localizedText } from "shared/lib/localizedMap";

import { ModifierDraft } from "features/ModifierSets/types";

import { Header, Info, List, Meta, Name, Row, RowActions, StopListMark, Title } from "./styles";

interface ModifierSetModifiersListProps {
    modifiers: ModifierDraft[];
    locale: string;
    currencyFormatter: CurrencyFormatter;
    onAdd: () => void;
    onEdit: (index: number) => void;
    onRemove: (index: number) => void;
}

export const ModifierSetModifiersList = ({
    modifiers,
    locale,
    currencyFormatter,
    onAdd,
    onEdit,
    onRemove,
}: ModifierSetModifiersListProps) => (
    <>
        <Header>
            <Title>Варианты</Title>
            <Button variant="outlined" onClick={onAdd}>
                <AddIcon fontSize="small" /> Добавить вариант
            </Button>
        </Header>

        {modifiers.length === 0 ? (
            <EmptyState description="В наборе пока нет вариантов — гостю нечего будет выбрать" />
        ) : (
            <List>
                {modifiers.map((modifier, index) => (
                    <Row key={modifier.id || `new_${index}`}>
                        <Info>
                            <Name>{localizedText(modifier.name, locale)}</Name>
                            <Meta>
                                {currencyFormatter.toShow(modifier.sellPrice)}
                                {modifier.isInStopList && (
                                    <StopListMark> · в стоп-листе</StopListMark>
                                )}
                            </Meta>
                        </Info>
                        <RowActions>
                            <Button variant="text" onClick={() => onEdit(index)}>
                                Изменить
                            </Button>
                            <Button variant="text" color="danger" onClick={() => onRemove(index)}>
                                Удалить
                            </Button>
                        </RowActions>
                    </Row>
                ))}
            </List>
        )}
    </>
);
